/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Group Chooser Icon component.
 */
export const GroupChooserIcon = ({size = IconSize.medium, color = Color.grey3}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <ThemeIconProvider name='GroupChooserIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M8 16C9.10457 16 10 15.1046 10 14C10 12.8954 9.10457 12 8 12C6.89543 12 6 12.8954 6 14C6 15.1046 6.89543 16 8 16Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12C14.8954 12 14 12.8954 14 14C14 15.1046 14.8954 16 16 16Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      </svg>
    )} />
  );
};
